export default "__VITE_ASSET__DTofDbnW__"